<template>
  <base-layout>
    <border-box slot="sidebar"><h2 v-html="heading"/></border-box>
    <grid-row slot="content">
      <div class="footer-section__col">
        <border-box>
          <grid-row>
            <div class="footer-section__col-inner">
              <ul class="footer-section__list">
                <li
                  v-for="(person, i) in team1"
                  :key="i"
                  class="footer-section__list-item"
                  v-html="person"
                />
              </ul>
            </div>
          </grid-row>
        </border-box>
      </div>
      <div class="footer-section__col">
        <border-box>
          <grid-row>
            <div
              class="footer-section__col-inner footer-section__col-inner--description"
              v-html="description"
            />
          </grid-row>
        </border-box>
      </div>
    </grid-row>
  </base-layout>
</template>

<script>
import BaseLayout from '@/components/BaseLayout'
import BorderBox from '@/components/BorderBox'

export default {
  components: {
    BaseLayout,
    BorderBox
  },
  props: {
    team1: {
      type: Array,
      default: () => []
    },
    description: {
      type: String,
      default: ''
    },
    heading: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .footer-section {
    &__col {
      @include vertical-space((bottom: 1), padding);
      @include grid-column((xs: 12, md: 6));

      &-inner {
        @include grid-column((xs: 12));

        /deep/ p:not(:last-child) {
          @include vertical-space((bottom: 1));
        }

        &--description {
          @include media-up(md) {
            margin-top: 13px;
          }

          @include media-up(lg) {
            margin-top: 16px;
          }
        }
      }

      @include media-up(lg) {
        &:nth-child(odd) {
          @include nested-column-width(4, 9, lg)
        }

        &:nth-child(even) {
          @include nested-column-width(5, 9, lg)
        }

        &:nth-child(even) &-inner {
          @include nested-column-width(4, 5, lg);
        }
      }
    }

    &__list {
      @include reset-list;
      line-height: 2 * $vertical-space;

      @include media-up(lg) {
        margin-top: 3px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Details/FooterSection.vue